import { useEffect } from 'react';

var handleKeyDown = function handleKeyDown(event, tokens, onTokenRemove, inputElement, tokenRef) {
  var _a, _b, _c, _d;
  if (event.key === "Enter" || event.key === " ") {
    var parent_1 = event.target.parentElement;
    var firstChildText_1 = (_a = parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.firstElementChild) === null || _a === void 0 ? void 0 : _a.innerText;
    var matchedItem = tokens.find(function (item) {
      return item.text === firstChildText_1;
    });
    if (tokenRef.current) {
      tokenRef.current === null;
    }
    if (matchedItem && ((_b = tokenRef.current) === null || _b === void 0 ? void 0 : _b.text) !== (matchedItem === null || matchedItem === void 0 ? void 0 : matchedItem.text)) {
      tokenRef.current = matchedItem;
      // Find the next sibling tag or previous sibling if there is no next sibling
      var prevSibling = parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.previousElementSibling;
      var nextSibling = parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.nextElementSibling;
      onTokenRemove(matchedItem.id);
      // Focus the next sibling if it exists, otherwise focus the previous sibling
      if (prevSibling && prevSibling.tagName === "SPAN") {
        (_c = prevSibling.querySelector("._RemoveTokenButton__StyledTokenButton-sc-urhpr1-0")) === null || _c === void 0 ? void 0 : _c.focus();
      } else if (nextSibling && nextSibling.tagName === "SPAN") {
        (_d = nextSibling.querySelector("._RemoveTokenButton__StyledTokenButton-sc-urhpr1-0")) === null || _d === void 0 ? void 0 : _d.focus();
      } else {
        // if no  sibling  exists, otherwise focus the input
        inputElement === null || inputElement === void 0 ? void 0 : inputElement.focus();
      }
    }
  }
};
var useFocusHandler = function useFocusHandler(_a) {
  var tokens = _a.tokens,
    onTokenRemove = _a.onTokenRemove,
    tagAriaLabelToAdd = _a.tagAriaLabelToAdd,
    tokenRef = _a.tokenRef,
    _b = _a.dependencies,
    dependencies = _b === void 0 ? [] : _b,
    // Providing a default empty array for dependencies
    inputElementId = _a.inputElementId;
  useEffect(function () {
    // Function to set attributes on the tags
    var setTagAttributes = function setTagAttributes(tags) {
      tags.forEach(function (tag) {
        tag.setAttribute("role", "button");
        tag.setAttribute("aria-label", tagAriaLabelToAdd);
        tag.setAttribute("tabindex", "0");
        tag.removeAttribute("aria-hidden");
      });
    };
    var handleFocus = function handleFocus() {
      setTimeout(function () {
        setTagAttributes(items);
      }, 0);
    };
    var items = document.querySelectorAll("._RemoveTokenButton__StyledTokenButton-sc-urhpr1-0");
    var parent = document.querySelector(".TextInputWrapper__TextInputBaseWrapper-sc-1mqhpbi-0");
    var searchInputElement = document.getElementById(inputElementId);
    setTimeout(function () {
      setTagAttributes(items);
      items.forEach(function (tag) {
        tag.addEventListener("focus", handleFocus);
        tag.addEventListener("keydown", function (event) {
          return handleKeyDown(event, tokens, onTokenRemove, searchInputElement, tokenRef);
        });
      });
    }, 0);
    // Add focusin and focusout event listeners to parent
    parent === null || parent === void 0 ? void 0 : parent.addEventListener("focusin", handleFocus);
    parent === null || parent === void 0 ? void 0 : parent.addEventListener("focusout", handleFocus);
    return function () {
      parent === null || parent === void 0 ? void 0 : parent.removeEventListener("focusin", handleFocus);
      parent === null || parent === void 0 ? void 0 : parent.removeEventListener("focusout", handleFocus);
      items.forEach(function (tag) {
        tag.removeEventListener("focus", handleFocus);
        tag.removeEventListener("keydown", function (event) {
          return handleKeyDown(event, tokens, onTokenRemove, searchInputElement, tokenRef);
        });
      });
    };
  }, dependencies);
};

export { handleKeyDown, useFocusHandler };
